import { render, staticRenderFns } from "./MessageRecipients.vue?vue&type=template&id=e577b0d6&scoped=true&"
import script from "./MessageRecipients.ts?vue&type=script&lang=ts&"
export * from "./MessageRecipients.ts?vue&type=script&lang=ts&"
import style0 from "./MessageRecipients.scss?vue&type=style&index=0&id=e577b0d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e577b0d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})
